export default "__VITE_ASSET__Bx$RYUrp__"